"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function AddThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
            react_1.default.createElement("rect", { width: "1", height: "12", x: "7.5", y: "2" }),
            react_1.default.createElement("rect", { width: "1", height: "12", x: "7.5", y: "2", transform: "rotate(90 8 8)" }))));
}
exports.default = AddThin;
//# sourceMappingURL=AddThin.js.map